import { NavigationService } from './services/navigation.service'
import { StatisticsService } from './services/statistics.service'

export function appInitializer(statsService: StatisticsService, navigationService: NavigationService) {
   statsService.initialize()
   navigationService.initialize()
}